import React from 'react';
import { Link } from 'react-router-dom';

// আসল site এর জন্য পরিষ্কার navigation — template এর demo submenu
// (Home Two/Three, Header Styles, One Page Styles, Event Prodigy/Stellar
// Events/Elite Event Management ইত্যাদি ভুয়া ব্যবসার নাম) সরানো হয়েছে।
const MenuItems = ({ parentMenu, activeMenu }) => {
  const pagesGroup = ['pricing', 'faq', 'gallery', 'gallery-details', 'testimonials', 'team', 'team-details'];
  const isPagesActive = pagesGroup.includes((parentMenu || '').toLowerCase());

  return (
    <ul className="main-menu__list">
      <li className={parentMenu === 'home' ? 'current-menu-item' : ''}>
        <Link to="/" className={activeMenu === '/' ? 'active-menu' : ''}>
          Home
        </Link>
      </li>
      <li className={parentMenu === 'events' ? 'current-menu-item' : ''}>
        <Link to="/events" className={activeMenu === '/events' ? 'active-menu' : ''}>
          Events
        </Link>
      </li>
      <li className={parentMenu === 'about' ? 'current-menu-item' : ''}>
        <Link to="/about" className={activeMenu === '/about' ? 'active-menu' : ''}>
          About
        </Link>
      </li>
      <li className={isPagesActive ? 'dropdown current-menu-item' : 'dropdown'}>
        <Link to="#">Pages</Link>
        <ul className="sub-menu">
          <li>
            <Link to="/team" className={activeMenu === '/team' ? 'active-menu' : ''}>
              Team
            </Link>
          </li>
          <li>
            <Link to="/testimonials" className={activeMenu === '/testimonials' ? 'active-menu' : ''}>
              Testimonials
            </Link>
          </li>
          <li>
            <Link to="/pricing" className={activeMenu === '/pricing' ? 'active-menu' : ''}>
              Pricing
            </Link>
          </li>
          <li>
            <Link to="/gallery" className={activeMenu === '/gallery' ? 'active-menu' : ''}>
              Gallery
            </Link>
          </li>
          <li>
            <Link to="/faq" className={activeMenu === '/faq' ? 'active-menu' : ''}>
              FAQ
            </Link>
          </li>
        </ul>
      </li>
      <li className={parentMenu === 'blog' ? 'dropdown current-menu-item' : 'dropdown'}>
        <Link to="#">Blog</Link>
        <ul className="sub-menu">
          <li>
            <Link to="/blog" className={activeMenu === '/blog' ? 'active-menu' : ''}>
              Blog
            </Link>
          </li>
          <li>
            <Link to="/blog-list" className={activeMenu === '/blog-list' ? 'active-menu' : ''}>
              Blog List
            </Link>
          </li>
        </ul>
      </li>
      <li className={parentMenu === 'contact' ? 'current-menu-item' : ''}>
        <Link to="/contact" className={activeMenu === '/contact' ? 'active-menu' : ''}>
          Contact
        </Link>
      </li>
    </ul>
  );
};

export default MenuItems;
